(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (root) => {
      const stage = root.querySelector('.msub-gallery-stage');
      if (!stage) return;
      const image = stage.querySelector('.msub-gallery-image');
      const thumbs = [...root.querySelectorAll('[data-msub-gallery-thumb]')];
      const counter = root.querySelector('[data-msub-gallery-current]');
      const prev = root.querySelector('[data-msub-gallery-prev]');
      const next = root.querySelector('[data-msub-gallery-next]');
      const navThumbs = root.querySelector('.msub-gallery-thumbs');
      const thumbPrev = navThumbs?.querySelector('.msub-gallery-thumb-nav--prev');
      const thumbNext = navThumbs?.querySelector('.msub-gallery-thumb-nav--next');
      if (!image || !thumbs.length) return;

      // Derive initial index from the is-active thumbnail, default 0
      let idx = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
      if (idx < 0) idx = 0;

      const update = (i) => {
        idx = ((i % thumbs.length) + thumbs.length) % thumbs.length;
        const t = thumbs[idx];
        if (t.dataset.fullSrc && image.tagName === 'IMG') {
          // Remove stale srcset before setting src so the browser uses the new src
          image.removeAttribute('srcset');
          image.src = t.dataset.fullSrc;
          image.alt = t.dataset.fullAlt || image.alt;
        }
        thumbs.forEach((thumb, j) => {
          const active = j === idx;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = String(idx + 1);
      };

      // Set initial aria-current on all thumbs
      thumbs.forEach((thumb, j) => {
        thumb.setAttribute('aria-current', j === idx ? 'true' : 'false');
      });

      thumbs.forEach((t, i) => t.addEventListener('click', () => update(i)));
      if (prev) prev.addEventListener('click', () => update(idx - 1));
      if (next) next.addEventListener('click', () => update(idx + 1));
      if (thumbPrev) thumbPrev.addEventListener('click', () => navThumbs.scrollBy({ left: -200, behavior: 'smooth' }));
      if (thumbNext) thumbNext.addEventListener('click', () => navThumbs.scrollBy({ left: 200, behavior: 'smooth' }));
    };

    const initQty = (root) => {
      const dec = root.querySelector('[data-msub-qty-dec]');
      const inc = root.querySelector('[data-msub-qty-inc]');
      const input = root.querySelector('[data-msub-qty-input]');
      if (!input) return;
      const clamp = (v) => Math.max(1, parseInt(v, 10) || 1);
      if (dec) dec.addEventListener('click', () => { input.value = String(clamp(input.value) - 1); });
      if (inc) inc.addEventListener('click', () => { input.value = String(clamp(input.value) + 1); });
    };

    const initSpecsToggle = (root) => {
      const link = root.querySelector('[data-msub-specs-toggle]');
      if (!link) return;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = root.querySelector('#msub-product-v1__accordion details');
        if (target) {
          target.setAttribute('open', '');
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    };

    const initATC = (root) => {
      const btn = root.querySelector('[data-msub-atc]');
      // 防双绑：dataset flag —— section reload / theme editor / dynamic section render 安全
      if (!btn || btn.dataset.atcBound === 'true') return;
      btn.dataset.atcBound = 'true';
      const input = root.querySelector('[data-msub-qty-input]');
      const originalText = btn.textContent.trim();

      const showMsg = (msg, isError) => {
        let el = root.querySelector('.msub-product-v1__atc-msg');
        if (!el) {
          el = document.createElement('p');
          el.className = 'msub-product-v1__atc-msg';
          el.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.4;font-weight:500;';
          btn.parentElement.appendChild(el);
        }
        el.style.color = isError ? '#b3261e' : '#006e47';
        el.textContent = msg;
        el.setAttribute('role', isError ? 'alert' : 'status');
        clearTimeout(el._timer);
        el._timer = setTimeout(() => el.remove(), 5000);
      };

      btn.addEventListener('click', async () => {
        // 防重复点击
        if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
        let variantId = btn.dataset.variantId;
        // CDN 旧缓存兜底：data-variant-id 缺失时从 storefront product JSON 拉 first variant
        if (!variantId) {
          const m = window.location.pathname.match(/\/products\/([^/]+)/);
          if (m) {
            try {
              const p = await fetch(`/products/${m[1]}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
              if (p && p.variants && p.variants[0]) variantId = String(p.variants[0].id);
            } catch (e) {}
          }
        }
        if (!variantId) {
          showMsg('This product is currently unavailable. Please contact support.', true);
          return;
        }
        const qty = Math.max(1, parseInt((input && input.value) || '1', 10) || 1);

        // loading 状态
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding...';

        const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
        const attempt = () => fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
        }).then((r) => r.json());

        let cart;
        try {
          cart = await attempt();
          if (cart.status) {
            if (cart.status === 429) {
              // 限流：最多一次合理重试，不疯狂重试
              await new Promise((r) => setTimeout(r, 1500));
              cart = await attempt();
            }
            if (cart.status) throw new Error(cart.message || 'Add to cart failed. Please try again.');
          }
        } catch (e) {
          // 失败：恢复按钮，不假装成功
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
          showMsg(e.message || 'Something went wrong. Please try again.', true);
          return;
        }

        // 成功：明确反馈 + 复用 Dawn 标准 cart UI（shopify:cart:lines-update 事件）
        btn.textContent = 'Added';
        btn.setAttribute('aria-busy', 'false');
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2500);

        let resolveEvt;
        const promise = new Promise((res) => { resolveEvt = res; });
        // Dawn 最新版 StandardEvents.cartLinesUpdate = 'shopify:cart:lines-update'
        // cart 组件读取 event.action / event.promise / event.detail —— 必须设全
        const evt = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: true });
        Object.defineProperty(evt, 'action', { value: 'add' });
        Object.defineProperty(evt, 'detail', {
          value: { action: 'add', items: cart.items, cart, source: 'msub-atc' },
        });
        Object.defineProperty(evt, 'promise', { value: promise });
        document.dispatchEvent(evt);
        resolveEvt({ cart, detail: { items: cart.items, cart, source: 'msub-atc' } });

        // 兜底：事件未触发 drawer open 时，手动打开 + 刷新内容
        setTimeout(() => {
          const drawer = document.getElementById('cart-drawer');
          if (drawer && !drawer.hasAttribute('open')) {
            customElements.whenDefined('theme-drawer').then(() => {
              if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
            });
          }
          customElements.whenDefined('cart-items-component').then(() => {
            const cic = document.querySelector('cart-items-component[data-drawer]');
            if (cic && typeof cic.fetchCartData === 'function') { try { cic.fetchCartData(); } catch (e) {} }
          });
        }, 600);
      });
    };

    document.querySelectorAll('.msub-product-v1').forEach((section) => {
      initGallery(section);
      initQty(section);
      initSpecsToggle(section);
      initATC(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
